import React from "react";
import Header from "./header";

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <main className="main__content_wrapper">{children}</main>
      {/* <Footer /> */}
    </>
  );
};

export default Layout;
